<template>
  <div class="alarm-record">
    <ComBox>
      <template #title>
        <TitleBar title="火点报警记录">
          <template #icon>
            <img
              src="@/assets/dataScreen/icon-record.png"
              style="width: 27.5px; height: 31px; margin-right: 8px"
            />
          </template>
        </TitleBar>
      </template>
      <div class="table-wrapper">
        <ComTable :columns="columns" :data="tableData" :scroll-step="66">
          <template #index="{ index }">
            <span>{{ index + 1 }}</span>
          </template>
          <template #image="{ data }">
            <img class="image" :src="data.eventImg" />
          </template>
          <template #status="{ data }">
            <span v-if="data.statusName === '已处理'" style="color: #1890FF"> {{ data.statusName }}</span>
            <span v-else style="color: #FF3400"> {{ data.statusName }}</span>
          </template>
        </ComTable>
      </div>
    </ComBox>
  </div>
</template>

<script>
  import TitleBar from "../../common/TitleBar.vue";
  import ComBox from "../../common/ComBox.vue";
  import ComTable from "../../common/ComTable.vue";
  import { getFireWarningRecords } from "@/api/dataScreen";
  export default {
    name: "AlarmRecord",
    components: { TitleBar, ComBox, ComTable },
    data() {
      return {
        columns: [
          {
            prop: "index",
            label: "序号",
            width: "10%",
            slot: "index",
          },
          {
            prop: "warningPoint",
            label: "报警点位",
            width: "20%",
          },
          {
            prop: "procesTime",
            label: "报警时间",
            width: "35%",
          },
          {
            prop: "eventImg",
            label: "火点照片",
            width: "15%",
            slot: "image",
          },
          {
            prop: "statusName",
            label: "状态",
            width: "10%",
            slot: 'status'
          },
        ],
        tableData: [],
      };
    },
    created() {
      this.getData()
    },
    mounted() {},
    methods: {
      getData() {
        getFireWarningRecords().then(res => {
          const list = res.data || []
          this.tableData = list
        })
      }
    },
  };
</script>

<style scoped lang="less">
  .alarm-record {
    width: 100%;
    height: auto;
    flex: 4;

    .table-wrapper {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      padding: 15px 0 5px;
      .image {
        width: 90px;
        height: 66px;
      }
    }
  }
</style>
